import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import {
  DataGrid,
  GridColDef,
  GridToolbar,
  // GridColumnVisibilityModel,
  // GridColTypeDef,
  GridValueFormatterParams,
} from "@mui/x-data-grid";
import { Box, Typography } from "@mui/material";
import { staff } from "../common/type";
import ClipLoader from "react-spinners/ClipLoader";
import { getExpectedPayments } from "../services/get.service";

const ExpextedPayment = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);
  const [rows, setRows] = useState<Array<staff>>([]);

  useEffect(() => {
    setLoading(true);

    getExpectedPayments()
      .then((res) => {
        setLoading(false);
        setRows(res.data);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  }, [setRows]);

  const columns: GridColDef[] = [
    { field: "patientName", headerName: "Patient Name", width: 170 },
    { field: "company", headerName: "Company", width: 170 },
    { field: "branch", headerName: "Branch", width: 170 },
    {
      field: "price",
      headerName: "Price",
      width: 170,
      type: "number",
      align: "left",
      headerAlign: "left",
    },
    {
      field: "paid",
      headerName: "Paid",
      width: 170,
      type: "number",
      align: "left",
      headerAlign: "left",
    },
    {
      field: "remaining",
      headerName: "Remaining",
      width: 170,
      type: "number",
      align: "left",
      headerAlign: "left",
    },
    { field: "name", headerName: "Treatment", width: 170 },
    {
      field: "start",
      headerName: "Start",
      width: 170,
      type: "date",
      valueFormatter: (val: GridValueFormatterParams<Date>) => {
        return new Date(val.value).toDateString();
      },
    },
    {
      field: "end",
      headerName: "End",
      width: 170,
      type: "date",
      valueFormatter: (val: GridValueFormatterParams<Date>) => {
        return new Date(val.value).toDateString();
      },
    },
  ];

  return (
    <>
      <Helmet>
        <title>{t("Expexted Payments")}</title>
      </Helmet>
      <div className="dark:text-black w-full">
        <div className="lg:m-12 m-4">
          <div className="bg-amber50 shadow-md rounded w-full px-3 lg:px-20 py-10 pt-5">
            <Typography variant="h4" fontSize={32} className="py-3">
              Expexted Payments
            </Typography>
            <Box sx={{ height: 520, width: "100%" }}>
              {loading ? (
                <ClipLoader loading={loading} size={70} />
              ) : rows !== undefined && rows.length > 0 ? (
                <DataGrid
                  rows={rows}
                  onRowClick={(r) => console.log(r.id)}
                  columns={columns}
                  slots={{ toolbar: GridToolbar }}
                />
              ) : (
                <DataGrid rows={[]} columns={columns} />
              )}
            </Box>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExpextedPayment;
